import {Stack} from './stack.structure';
import {IStack} from './stack.interface';


export class LimitedHistoryStack<T> extends Stack implements IStack {

	constructor(maxSize:number = 2048) {
		super(maxSize);
	}

	// @Override
	public push(elm:T):boolean {
		if (this.size === this._maxSize) {
			this._elements.shift();
		}
		this._elements.push(elm);
		return true;
	}
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/dataStructures/collections/stack/limitedHistoryStack.structure.ts